import { createAction } from 'typesafe-actions';

import { SendLogPayload } from './log.types';

export const SEND_LOG = 'SEND_LOG';

export const sendLog = createAction(SEND_LOG)<SendLogPayload>();
